import { useEffect, useState } from "react"
import { private_server } from "../../../config"
import { onGetErrorMessage, updateAuthorizationHeader } from "../../../shared/utility"


const usePurchaseGroupsView = ({ history, language }) => {

    const [loading, setLoading] = useState(false)
    const [sending, setSending] = useState(false)
    const [error, setError] = useState(null)

    const [purchase_group, setPurchaseGroup] = useState([])
    const [selected, setSelected] = useState(null)
    
    const [total, setTotal] = useState(0)
    const [tableFilter, setTableFilter] = useState({limit:10, offset:0, order:1, order_by:'id_purchase_group'})
    const [search, setSearch] = useState('')

    const [modals, setModals] = useState({
        add_purchase:false,
        delete_purchase:false
    })

    useEffect(() => {
        actions.onInitModule()
    }, [tableFilter])


    const actions = {
        onInitModule: async() => {
            try {
                setLoading(true)
                updateAuthorizationHeader(private_server)
                const {limit, offset, order_by, order} = tableFilter
                const params = {limit:limit, offset:offset*limit, order_by:order_by, order:order}
                const req = await private_server.get(`purchasegroup/all?&filter={"AND":[{"field":"name","operator":"LIKE","value":"%25${search}%25"}]}`, {params:{...params}})
                console.log(req)
                const _groups = req.data.data
                setPurchaseGroup(_groups.purchase_groups)
                setTotal(_groups.count)
                setLoading(false)
            } catch (error) {
                console.log(error)
                const _error = onGetErrorMessage(error, language)
                setError(_error ? _error.message : null)
                setLoading(false)
            }
        },
        onSelectItem: (id, action) => {
            if(action === 'edit') history.push(`purchase-groups/${id}`)
            if(action === 'delete'){
                setSelected(id)
                actions.onChangeModalStatus('delete_purchase', true)
            }
        },
        onChangeModalStatus: (key, status) => {
            let _modals = {...modals}
            _modals[key] = status
            setModals(_modals)
        },
        onResetTableFiler: () => setTableFilter({limit:10, offset:0, order:1, order_by:'id_purchase_group'}),
        onChangeSearch: (value)=>{
            /* let newTableFilter = {...tableFilter}
            newTableFilter.offset = 0
            setTableFilter(newTableFilter) */
            setSearch(value)
        },
        onChangeTableFilter: (newTableFilter) => { 
            //let newTableFilter = {...tableFilter}
            //newTableFilter.offset = 0
            setTableFilter(newTableFilter)
        },
        onCompleted:async () =>{
            try {
                setLoading(true)
                updateAuthorizationHeader(private_server)
                const req = await private_server.get(`purchasegroup/all`, {params:{...tableFilter}})
                console.log(req)
                const _groups = req.data.data
                setPurchaseGroup(_groups.purchase_groups)
                setTotal(_groups.count)
                setLoading(false)
            } catch (error) {
                console.log(error)
                const _error = onGetErrorMessage(error, language)
                setError(_error ? _error.message : null)
                setLoading(false)
            }
        },
        onClearError:()=>{
            setError(null)
        }
    }

    const system = {loading, sending, error}
    const view_data = {purchase_group, total, tableFilter, search, selected}

    return {system, modals, view_data, actions}
}

export default usePurchaseGroupsView